import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-6" }
const _hoisted_2 = { class: "mb-2 form-inline" }
const _hoisted_3 = {
  for: "bookName",
  class: "col-4 justify-content-start"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form-inline mb-2" }
const _hoisted_6 = {
  for: "bookPublisher",
  class: "col-4 justify-content-start"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-inline mb-2" }
const _hoisted_9 = {
  for: "bookFrom",
  class: "col-4 justify-content-start"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-inline mb-2" }
const _hoisted_13 = {
  for: "bookTo",
  class: "col-4 justify-content-start"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("messages.name")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "bookName",
        class: "form-control col-8",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editableBook.name = $event)),
        placeholder: _ctx.$t('messages.book name')
      }, null, 8, _hoisted_4), [
        [_vModelText, _ctx.editableBook.name],
        [_directive_focus]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.Publisher")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "bookPublisher",
        class: "form-control col-8",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editableBook.publisher = $event)),
        placeholder: _ctx.$t('messages.publisher')
      }, null, 8, _hoisted_7), [
        [_vModelText, _ctx.editableBook.publisher]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.source language")), 1),
      _withDirectives(_createElementVNode("select", {
        class: "custom-select col-8",
        id: "bookFrom",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableBook.languageFrom = $event)),
        disabled: !_ctx.isNewBook
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createElementBlock("option", {
            key: language.name,
            value: language.name
          }, _toDisplayString(language.fullname), 9, _hoisted_11))
        }), 128))
      ], 8, _hoisted_10), [
        [_vModelSelect, _ctx.editableBook.languageFrom]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("messages.target language")), 1),
      _withDirectives(_createElementVNode("select", {
        class: "custom-select col-8",
        id: "bookTo",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editableBook.languageTo = $event)),
        disabled: !_ctx.isNewBook
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createElementBlock("option", {
            key: language.name,
            value: language.name
          }, _toDisplayString(language.fullname), 9, _hoisted_15))
        }), 128))
      ], 8, _hoisted_14), [
        [_vModelSelect, _ctx.editableBook.languageTo]
      ])
    ]),
    _createElementVNode("button", {
      class: "btn-primary btn float-right",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveChanges(_ctx.editableBook)))
    }, [
      _hoisted_16,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.save settings")), 1)
    ])
  ]))
}